import { Component } from '@angular/core';

@Component({ standalone: false, selector: 'app-one-column',
  templateUrl: './one-column.component.html',
  styleUrls: ['./one-column.component.scss']
})
export class OneColumnComponent {


}
